import React from 'react'
import './ctaband.css'
import { useTour } from '../tour/TourContext'
import { SCHOOL_PHONE, SCHOOL_PHONE_LINK } from '../../config'
import penelope_gif from '../../assets/Logo Waving.gif'

export default function CtaBand() {
  const { openRequest } = useTour()

  return (
    <section className="cta-section">
      <div className="cta-card">
        <img className="cta-hippo" src={penelope_gif} alt="Penelope the hippo waving" />
        <div className="cta-copy">
          <h2>Come say hi!</h2>
          <p>Meet our teachers, see the classrooms, and find the right spot for your little one.</p>
        </div>
        <div className="cta-actions">
          <button type="button" className="btn btn-purple" onClick={openRequest}>
            Schedule a Tour
          </button>
          <a className="cta-phone" href={SCHOOL_PHONE_LINK}>
            or call {SCHOOL_PHONE}
          </a>
        </div>
      </div>
    </section>
  )
}
